import { css, styled } from "styled-components";
import { P } from "@template/components/typography/styles";

export const HeroWrapper = styled.div<{
  $altStyling?: boolean;
  $greyBackground?: boolean;
}>`
  background: ${({ theme, $altStyling }) =>
  $altStyling ? theme.colors.primary[950] : theme.colors.base};
  background-color: ${({ theme, $greyBackground }) =>
  $greyBackground ? theme.colors.default[50] : undefined};
  height: 100%;
  display: flex;
  padding: 64px 24px ${({ $altStyling }) => ($altStyling ? "0" : "96px")};
  gap: 24px;
  align-items: center;
  justify-content: center;
  position: relative;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
  }
`;

export const Container = styled.div<{ $column?: boolean }>`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${({ $column }) => ($column ? "column" : "row")};
  gap: ${({ $column }) => ($column ? "48px" : "0")};

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
  }
`;

export const HeroContainer = styled.div<{ $column?: boolean }>`
  max-width: ${({ $column }) => ($column ? "100%" : "600px")};
  text-align: ${({ $column }) => ($column ? "center" : "start")};
`;

export const Header = styled.div<{ $altStyling?: boolean }>`
  color: ${({ theme, $altStyling }) =>
  $altStyling ? theme.colors.primary[50] : theme.colors.default[900]};
  padding-bottom: 12px;
`;

export const Subheader = styled.div<{ $altStyling?: boolean }>`
  ${({ theme, $altStyling }) =>
  $altStyling
    ? css`
          color: ${theme.colors.default[50]};

          ${P} {
            color: ${theme.colors.default[50]};
          }
        `
    : css`
          color: ${theme.colors.default[900]};

          ${P} {
            color: ${theme.colors.default[900]};
          }
        `};
  padding-bottom: 24px;
  margin-left: auto;
  margin-right: auto;

  & a {
    text-decoration: underline;
  }
`;

export const ButtonGroup = styled.div<{ $column?: boolean }>`
  display: flex;
  font-size: 18px;
  gap: 12px;
  padding-bottom: 24px;
  flex-wrap: wrap;
  justify-content: ${({ $column }) => ($column ? "center" : "start")};
`;

export const HeroImageContainer = styled.div`
  max-width: 600px;
  max-height: 708px;
  width: 100%;

  video {
    isolation: isolate;
  }
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: -1px;

  @media (min-width: 2400px) {
    display: none;
  }
`;
